import { render, staticRenderFns } from "./SendingRules.vue?vue&type=template&id=78477c33&scoped=true&"
import script from "./SendingRules.vue?vue&type=script&lang=js&"
export * from "./SendingRules.vue?vue&type=script&lang=js&"
import style0 from "./SendingRules.vue?vue&type=style&index=0&id=78477c33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78477c33",
  null
  
)

export default component.exports